import { render, staticRenderFns } from "./kc_form1200.vue?vue&type=template&id=3c0390e3"
import script from "./kc_form1200.vue?vue&type=script&lang=js"
export * from "./kc_form1200.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports